export default __webpack_public_path__ + "static/media/TGA-dark.491f039d.png";